import React from 'react';
import { SortFull, SortHalf } from '@yme/assets/icons';
import { Dropdown } from '@yme/atoms/dropdown';
import { useSortFilter } from '@yme/components/SearchPage/hooks';
import { useTranslation } from '@yme/services/i18n';
export function SortingFilter({ category, isInfiniteDesktopView, isRightToLeft, callback, }) {
    const { t } = useTranslation();
    const sortingProps = useSortFilter({
        callback,
    });
    return (React.createElement(Dropdown, { id: `${category}_sorting`, title: t('filters_sortBy_label'), labelText: isInfiniteDesktopView ? t('filters_sortBy_label') : undefined, isInheritBackground: true, useForMobile: true, hasRadioButton: true, leftSideIconType: isInfiniteDesktopView ? SortFull : SortHalf, isRightToLeft: isRightToLeft, items: sortingProps.sortingOptions, activeItem: sortingProps.sortOrder, onChange: sortingProps.handleSortOrderChange }));
}
